import { BaseService } from 'core/services';
import ReportingIntervalTypeRouteService from './ReportingIntervalTypeRouteService';

class ReportingIntervalTypeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ReportingIntervalTypeRouteService());
    }
}

export default ReportingIntervalTypeService;
